import React from "react";

import SectionHeader from "../../layout/SectionHeader";
import FeatureBox from "./FeatureBox";

import featuresBackground from "./assets/features-section-background.png";
import "./styles/Features.css";

const Features = () => {
  return (
    <section className="section-features" id="section-features">
      <div className="featuresBackgroundLayer" />
      <div
        className="section-features__container"
        style={{ background: `url(${featuresBackground})` }}
      >
        <SectionHeader
          marginBottom="medium"
          headerAlign="center"
          colourPrimary="rgba(255,255,255,.85)"
          colourSecondary="rgba(240,240,240,.85)"
          title="Experience"
        />
        <div className="row">
          <div className="col-1-of-4">
            <FeatureBox
              title="Vision & Wireframes"
              description="Every project should start with a vision and I am skilled with a number of vision-building tools to get us started."
              icon="basic-notebook-pencil"
            />
          </div>
          <div className="col-1-of-4">
            <FeatureBox
              title="Timeline & Budget"
              description="I am comfortable crunching the numbers and can accurately assemble a timeline and budget for completing almost any project."
              icon="basic-calendar"
            />
          </div>
          <div className="col-1-of-4">
            <FeatureBox
              title="Analytics & SEO"
              description="My experience with Google business and Google analytics tools helps me to provide the best search result outcomes for your project."
              icon="basic-target"
            />
          </div>
          <div className="col-1-of-4">
            <FeatureBox
              title="Development & UI"
              description="With a background spanning numerous years, development languages and designs, I'm confident we can build the user experience you want."
              icon="basic-star"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;



// WEBPACK FOOTER //
// ./src/components/sections/Section-Features/Features.js